import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/hooks";
import { useSelector } from "react-redux";
import { isBoolean, isEmpty } from "lodash";
import { RootState } from "../../redux/store";
import { useForm } from "react-hook-form";
import { useGetManagersQuery } from "../../hooks/useGetManagersQuery";
import { useMutation, useQuery } from "react-query";
import { createManager } from "../../services/school/manager/createManager";
import toast from "react-hot-toast";
import { updateManager } from "../../services/school/manager/updateManager";
import { TrashIcon } from "@radix-ui/react-icons";
import { Card, Flex, Button, Spinner, Badge, Separator } from "@radix-ui/themes";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import SelectComponent from "../../components/inputs/Select/SelectComponent";
import { routes } from "../../routes";
import { Create_Edit_User } from "../Users/Create_Edit_User/Create_Edit_User";
import { debounce } from "lodash";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { resetStudentData } from "../../redux/slices/school/student";
import { resetUserData, setUserData } from "../../redux/slices/users/user";
import { ManagerType } from "../../types/Manager";
import { UserPreview } from "../Users/UserPreview";
import RadioGroupComponent from "../../components/inputs/RadioGroup/RadioGroupComponent";
import DateFieldComponent from "../../components/inputs/Datefield/DatefieldComponent";
import { createUser } from "../../services/user/createUser";
import { useGetUserByBi } from "../../hooks/useGetUserByBi";
import { key_userBi, key_userNuit } from "../../utils/constants";
import { getUserByBI, getUserByNuit } from "../../services/user/getUsers";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { resetUpdateCourseData } from "../../redux/slices/school/course";
import { resetUpdateDepartamentData } from "../../redux/slices/school/departament";
import { resetUpdateFacultyData } from "../../redux/slices/school/faculty";
import { resetPreviousPath } from "../../redux/slices/previousPath";
import { UserType } from "../../types/User";
import { addUserRole } from "../../services/user/addUserRole";
import { useGetRolesQuery } from "../../hooks/useGetRolesQuery";
import { yupResolver } from "@hookform/resolvers/yup";
import { CreateManagerValidationForm } from "./CreateManagerValidationForm";
import { removeUserRole } from "../../services/user/removeUserRole";
import { getAllStaticRoles } from "../../staticRoles";
import { Countries, Country } from "../../utils/codes";
import SelectSearchableComponent from "../../components/inputs/Select/SelectSearchableComponent";

const columnNamesMap: { [key: string]: string } = {
  fullname: "Nome",
  //  faculty: "Unidade orgânica",
  //departament: "Departamento",
  //course: "Curso",
  role: "Cargo",
};
export const AssignManager = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItem, setDeleteItem] = useState<ManagerType | null>(null);
  const openDeleteDialog = (s: ManagerType) => {
    setDeleteItem(s);
  };
  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem!);
    }
  };

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const universityData = useSelector((state: RootState) => state.university);
  const { description, province } = universityData;
  const facultyData = useSelector((state: RootState) => state.faculty);
  const departamentData = useSelector((state: RootState) => state.departament);
  const courseData = useSelector((state: RootState) => state.course);
  const previousPath = useSelector((state: RootState) => state.previousPath);
  const mutationAddUserRole = useMutation({
    mutationKey: "addUserRole",
    mutationFn: addUserRole,
  });
  const { data: roles } = useGetRolesQuery({ PageNumber: 1, PageSize: 400 });

  const storedIds = {
    idFaculty:
      previousPath.previousPath === routes.faculties
        ? facultyData.id
        : facultyData?.id || undefined,
          // || departamentData?.idFaculty || courseData?.idFaculty || undefined
    idUniversity:
      previousPath.previousPath === routes.universities
        ? universityData.id
        : universityData?.id || undefined,
          // || departamentData?.idFaculty || courseData?.idFaculty || undefined
    idDepartament:
      previousPath.previousPath === routes.departaments
        ? departamentData.id
        : departamentData?.id || undefined,
          // || courseData?.idDepartament || undefined
    idCourse:
      previousPath.previousPath === routes.courses
        ? courseData.id
        : courseData?.id || undefined,
  };

  const userData = useSelector((state: RootState) => state.user);
  const mutationCreateUser = useMutation({
    mutationFn: createUser,
    mutationKey: "createUser",
  });
  const mutation = useMutation(createManager, {
    onSuccess: () => {
      toast.success("Vinculado!");
    },
    onError: () => {
      toast.error("Erro ao vincular.");
    },
  });
  const mutationDelete = useMutation(updateManager, {
    onSuccess: () => {
      toast.success("Vinculo removido!");
    },
    onError: () => {
      toast.error("Erro ao remover associação.");
    },
  });

  const handleOnChangeIsForeign = (e: any) => {
    const isIsForeign = stringToBoolean(getValues("user.isForeign"));
    if (isIsForeign) {
      resetField("user.nuit");
      setValue("user.countryDescription", "");
    }
    if (!isIsForeign) {
      setValue("user.countryDescription", "MOZ");
    }
  };
  const stringToBoolean = (str?: any): boolean => {
    if (!str) return false;
    try {
      if (isBoolean(str)) {
        return str;
      } else {
        return str.toLowerCase() === "true";
      }
    } catch (ex) {
      return false;
    }
  };
  type ManagerFormValues = Omit<ManagerType, "user"> &
    Omit<ManagerType, "idRole"> & {
      user: UserType;
      idRole: string;
    };
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    trigger,
    watch,
    reset,
    resetField,
  } = useForm<ManagerFormValues>({
    resolver: yupResolver(CreateManagerValidationForm),
    defaultValues: {
      ...storedIds,
      idUser: "",
      fullname: "",
      searchNuit: "",
      searchBi: "",
      user: {
        bi: "",
        nuit: "",
      },
      idRole: "",
      isManager: true,
    },
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUseNativeValidation: false,
  });
  const watchIsForeign = watch("user.isForeign");
  const {
    data: managers,
    isLoading: loadingManagers,
    refetch: refreshManagers,
    status: statusManagers,
  } = useGetManagersQuery(
    {
      PageSize: 400,
      PageNumber: 1,
      IdUniversity:
        previousPath.previousPath === routes.universities
          ? universityData.id
          : undefined,
      IdFaculty:
        previousPath.previousPath === routes.faculties
          ? facultyData.id
          : undefined,
      IdDepartament:
        previousPath.previousPath === routes.departaments
          ? departamentData.id
          : undefined,
      IdCourse:
        previousPath.previousPath === routes.courses
          ? courseData.id
          : undefined,
    }
    //,
    //  { enabled: !!facultyData.id || !!departamentData.id || !!courseData.id}
  );
  // const { data: managers, isLoading: loadingManagers, refetch: refreshManagers, status: statusManagers } = useGetManagersQuery(
  //     {
  //         PageSize: 400,
  //         PageNumber: 1,
  //         ...storedIds,
  //     },
  //     //{ enabled: !!facultyData.id || !!departamentData.id || !!courseData.id }
  // );
  // const { data: userBi, isLoading: loadingUserByBi, refetch: fetchUserByBi, status: statusUserByBi } = useGetUserByBi(getValues('user.bi') ,
  //     { enabled: false }
  // );
  // const { data: userNuit, isLoading: loadingUserByNuit, refetch: refreshUserByNuit, status: statusUserByNuit } = useGetUserByBi(getValues('user.nuit') ,
  //     { enabled: false }
  // );
  const { isLoading: loadingUserByBi, refetch: fetchUserByBi } = useQuery(
    [key_userBi],
    async () => {
      try {
        const userData = await getUserByBI(getValues("searchBi")!);
        if (!userData) return;
        reset({
          searchBi: getValues("searchBi")!,
          ...storedIds,
          idUser: userData.id,
          fullname: userData.name,
          status: true,
          user: userData,
          isManager: true,
        });
        return userData;
      } catch (error) {}
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
  const { isLoading: loadingUserByNuit, refetch: fetchUserByNuit } = useQuery(
    [key_userNuit],
    async () => {
      try {
        const userData = await getUserByNuit(getValues("searchNuit")!);
        if (!userData) return;
        reset({
          searchBi: getValues("searchBi")!,
          ...storedIds,
          idUser: userData.id,
          fullname: userData.name,
          status: true,
          user: userData,
        });
        return userData;
      } catch (error) {}
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
  const onSubmit = handleSubmit(async (data) => {
    try {
      if (!data.idUser || !data.user?.id) {
        const resultCreateUser = await mutationCreateUser.mutateAsync(
          data.user!
        );
        if (!resultCreateUser) return;
        const { id: idUser } = resultCreateUser as any;
        data.idUser = idUser;
      }
      try {
        await mutationAddUserRole.mutateAsync({
          roleId: data.idRole ?? "",
          userId: data.idUser!,
        });
      } catch (error) {
        console.error(error);
      }
      const result = await mutation.mutateAsync({
        ...data,
        fullname: data.user.name,
      });
      if (result) {
        refreshManagers();
        reset({
          ...storedIds,
          idUser: "",
          user: undefined,
          idRole: "",
          role: "",
        });
      }
    } catch (err: any) {}
  });
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleDelete = async (manager: any) => {
    manager.status = false;
    await mutationDelete.mutateAsync(manager);
    try {
      await removeUserRole({
        userId: manager.idUser,
        roleId: manager.idRole,
      });
    } catch (ex) {
      console.error(ex);
    }
    refreshManagers();
  };
  const options =
    managers?.items.map(() => [
      {
        label: "Excluir",
        onClick: (manager: any) => openDeleteDialog(manager),
        icon: <TrashIcon />,
      },
    ]) || [];

  const handleBIChange = useCallback(
    debounce((value: string) => {
      const trimmedValue = value.trim();
      setValue("searchBi", trimmedValue);
      if (trimmedValue.length >= 10) {
        fetchUserByBi();
      } else {
      }
    }, 300),
    [setValue, fetchUserByBi]
  );
  const handleNUITChange = useCallback(
    debounce((value: string) => {
      const trimmedValue = value.trim();
      setValue("searchNuit", trimmedValue);
      if (trimmedValue.length >= 8) {
        fetchUserByNuit();
      } else {
      }
    }, 300),
    [setValue, fetchUserByNuit]
  );

  const handleEmailChange = (e: any) => {
    const email = e.target.value;
    setValue("user.email", email);
    setValue("user.userName", email);
  };

  const handleFullnameChange = (e: any) => {
    const fullname = e.target.value;
    setValue("user.name", fullname);
    setValue("fullname", fullname);
  };
  const HandleRoleChange = (idRole: string) => {
    setValue("idRole", idRole);
    const role = roles?.items.find((r) => r.id === idRole)?.name;
    setValue("role", role);
  };
  const handleBack = () => {
    dispatch(resetUpdateFacultyData());
    dispatch(resetUpdateCourseData());
    dispatch(resetUpdateDepartamentData());
    const path = previousPath.previousPath!;
    dispatch(resetPreviousPath());
    navigate(path);
  };
  const filteredRoles = roles?.items.filter(
    (role) => !getAllStaticRoles().includes(role.name!)
  );
  return (
    <Card size="3">
      <Flex direction="row" gap="6">
        <Flex direction="column" gap="5" style={{ flex: 1 }}>

          <Flex align="center">
            <Badge variant="surface" >{province}</Badge>
            <Separator orientation="horizontal" />
            <Badge variant="outline" >{description}</Badge>
          </Flex>

          <form onSubmit={onSubmit} noValidate>
            <Flex direction="column" gap="4">
              <Flex gap="2">
                <TextFieldComponent
                  style={{ width: "100%" }}
                  name="searchBi"
                  label="Procurar por BI"
                  control={control}
                  errors={errors}
                  fieldProps={{
                    placeholder: "Procurar por BI",
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                      handleBIChange(e.target.value),
                    onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => {
                      e.preventDefault();
                      const pastedText = e.clipboardData.getData("text");
                      handleBIChange(pastedText);
                    },
                  }}
                />
                <TextFieldComponent
                  style={{ width: "100%" }}
                  name="searchNuit"
                  label="Procurar por NUIT"
                  control={control}
                  errors={errors}
                  fieldProps={{
                    placeholder: "Procurar por NUIT",
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                      handleNUITChange(e.target.value),
                    onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => {
                      e.preventDefault();
                      const pastedText = e.clipboardData.getData("text");
                      handleNUITChange(pastedText);
                    },
                  }}
                />
              </Flex>
              <Flex gap="8">
                <TextFieldComponent
                  name="user.name"
                  composedName={{ parent: "user", prop: "name" }}
                  label="Nome"
                  control={control}
                  errors={errors}
                  fieldProps={{
                    placeholder: "Nome completo",
                    onChange: handleFullnameChange,
                    type: "text",
                  }}
                  style={{ width: "100%" }}
                  required={true}
                />
                <TextFieldComponent
                  name="user.userName"
                  composedName={{ parent: "user", prop: "userName" }}
                  label="Utilizador"
                  control={control}
                  errors={errors}
                  fieldProps={{
                    placeholder: "Utilizador",
                    disabled: "disabled",
                  }}
                  style={{ width: "100%" }}
                  required={true}
                />
                <TextFieldComponent
                  name="user.email"
                  composedName={{ parent: "user", prop: "email" }}
                  label="Email"
                  control={control}
                  errors={errors}
                  fieldProps={{
                    placeholder: "seu@email.com",
                    onChange: handleEmailChange,
                    type: "email",
                  }}
                  style={{ width: "100%" }}
                  required={true}
                />
              </Flex>
              <Flex gap="8">
                <TextFieldComponent
                  name="user.bi"
                  composedName={{ parent: "user", prop: "bi" }}
                  label="BI"
                  control={control}
                  errors={errors}
                  fieldProps={{ placeholder: "BI" }}
                  style={{ width: "100%" }}
                  required={true}
                />
                <TextFieldComponent
                  name="user.nuit"
                  composedName={{ parent: "user", prop: "nuit" }}
                  label="NUIT"
                  control={control}
                  errors={errors}
                  fieldProps={{ placeholder: "Seu NUIT" }}
                  style={{ width: "100%" }}
                  required={true}
                />
                <TextFieldComponent
                  name="user.phoneNumber"
                  composedName={{ parent: "user", prop: "phoneNumber" }}
                  label="Telefone"
                  control={control}
                  errors={errors}
                  fieldProps={{ placeholder: "82xxxxxxx" }}
                  style={{ width: "100%" }}
                  required={true}
                />
                
            <TextFieldComponent
              name="user.secondaryPhoneNumber"
              composedName={{ parent: "user", prop: "secondaryPhoneNumber" }}
                  label="Telefone"
                  control={control}
                  errors={errors}
                  fieldProps={{ placeholder: "82xxxxxxx" }}
                  style={{ width: "100%" }}
            />

              </Flex>
              <Flex gap="8">
                <DateFieldComponent
                  name="user.dateOfBirth"
                  composedName={{ parent: "user", prop: "dateOfBirth" }}
                  label="Data de Nascimento"
                  control={control}
                  errors={errors}
                  style={{ width: "32%" }}
                  required={true}
                />
                <RadioGroupComponent
                  name="user.gender"
                  composedName={{ parent: "user", prop: "gender" }}
                  label="Gênero"
                  control={control}
                  errors={errors}
                  style={{ width: "68%" }}
                  options={[
                    { value: "M", label: "Masculino" },
                    { value: "F", label: "Feminino" },
                  ]}
                  fieldProps={{
                    style: {
                      display: "flex",
                      flexDirection: "row",
                      gap: "16px",
                    },
                  }}
                />
              </Flex>
              <Flex gap="6">
                <RadioGroupComponent
                  name="user.isForeign"
                  label="Estrangeiro"
                  control={control}
                  errors={errors}
                  style={{ width: "50%" }}
                  options={[
                    { value: "true", label: "Sim" },
                    { value: "false", label: "Não" },
                  ]}
                  fieldProps={{
                    style: {
                      display: "flex",
                      flexDirection: "row",
                      gap: "16px",
                    },
                    onChange: handleOnChangeIsForeign,
                  }}
                />
                <SelectSearchableComponent
                  name="user.countryDescription"
                  label="País"
                  control={control}
                  errors={errors}
                  options={Countries?.map((country: Country) => ({
                    value: country.code,
                    label: country.label ?? "",
                  }))}
                  style={{ width: "100%" }}
                  fieldProps={{ disabled: !stringToBoolean(watchIsForeign) }}
                />
              </Flex>
              <Flex>
                <SelectComponent
                  name="idRole"
                  label="Perfil"
                  control={control}
                  errors={errors}
                  style={{ width: "100%" }}
                  options={filteredRoles?.map((role) => ({
                    value: role.id ?? "",
                    label: role.name ?? "",
                  }))}
                  onSelect={HandleRoleChange}
                  required={true}
                />
              </Flex>

              <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
                <Button
                  color="red"
                  onClick={(e) => {
                    e.preventDefault();
                    handleBack();
                  }}
                >
                  Sair
                </Button>
                <Button
                  type="submit"
                  variant="surface"
                  disabled={mutation.isLoading}
                >
                  {mutation.isLoading ? <Spinner loading /> : "Vincular"}
                </Button>
              </Flex>
            </Flex>
          </form>
        </Flex>
        <Flex direction="column" gap="4" style={{ flex: 1 }}>
          <Lists
            status={statusManagers}
            TableComponent={() => (
              <TableComponent
                columns={Object.keys(columnNamesMap)}
                items={managers?.items}
                options={options}
                columnNamesMap={columnNamesMap}
                totalPages={managers?.totalPages || 1}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            )}
            handleClickCreate={undefined}
          />
          <ConfirmAlertDialog
            open={!!deleteItem}
            onOpenChange={(open) => !open && setDeleteItem(null)}
            title="Esta operação é irreversível"
            item={deleteItem}
            onConfirm={confirmDelete}
            onCancel={() => setDeleteItem(null)}
          />
        </Flex>
      </Flex>
    </Card>
  );
};
